
// import { Suspense } from 'react';
import './App.css';
import './Call.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import 'animate.css';
import '../src/components/Admin/admin.css'
import 'react-responsive-modal/styles.css';
import '../src/components/DailyReport/report.css'
import 'react-modern-drawer/dist/index.css'
import 'react-phone-input-2/lib/style.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-datepicker/dist/react-datepicker.css';
import './styles/DashboardCalender.css'
import './styles/icons.css'
import './styles/icons.css'
import { useSelector } from 'react-redux';
import CallRinging from './components/Call_window/Popup/CallRinging';
import SocketClient from "./Utils/SocketClient";
import useViewportHeight from './hooks/useViewportHeight';


function App() {
  useViewportHeight();
  const { callringpopup, user: reduxUser, allUsers, updateVersion_data } = useSelector(state => state.message);
  const localUser = localStorage.getItem('localUser');
  const user = reduxUser || JSON.parse(localUser);

  return (
    <>
      {user && allUsers && <SocketClient user={user} users={allUsers} />}
      {callringpopup.status && <CallRinging user={user} callringpopup={callringpopup} />}
      {updateVersion_data === "yes" ? (
        <div className="backwrap">
          <div className="upgrade_section">
            <div className="reloadIcon"></div>
            <div className="upgrade_title"> New application version detected </div>
            <div className="upgrade_btn">
              <button
                name="upgrade_btn"
                onClick={() => {
                  window.location.reload(true);
                  setInterval(() => window.location.reload(true), 3000);
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <RouterProvider router={router} />
    </>
  );
}

export default App;
